export const formatResponse = (response: { id: string; name: string }[]) =>
  response.map(({ id, name, ...rest }) => (id ? { label: name, value: id, data: rest } : rest));

export const getFormValidationRules = (comment?: string, feedbackDate?: Date) => {
  return {
    Description: () => !!comment?.length,
    Date: () => !!feedbackDate,
  };
};
